import React from 'react';
import {Element} from 'react-scroll'
import './Portfolio.css';

function Portfolio(){
    return(
      <Element className='port__container' id='portfolio'>
        <div className='portfolio__web'>
          <div className='port__about'>
              <h1>about</h1><br/>
              <p>i'm a self-taught web developer with a great passion for creating beautiful websites.</p>
          </div>
          <div className='port__skill'>
              <h1>skills</h1>
              <div className='icon_container'>
              <div className='icon_skill'><i class="fab fa-html5"></i><br/><span>html5</span></div>
             <div className='icon_skill'><i class="fab fa-css3-alt"></i><br/><span>css3</span></div>
             <div className='icon_skill'><i class="fab fa-js-square"></i><br/><span>javaScript</span></div>
             <div className='icon_skill'><i class="fab fa-bootstrap"></i><br/><span>bootstrap</span></div>
             <div className='icon_skill'><i class="fab fa-react"></i><br/><span>reactjs</span></div>
             <div className='icon_skill'><i class="fab fa-java"></i><br/><span>core java</span></div>
             </div>
          </div>
        </div>
       
      </Element>
    )
}
export default Portfolio;